<template>
  <div class="shop-form__block mb-10px">
    <h2 class="step-finish__title" v-if="false">Оплата прошла успешно!</h2>

    <div class="order-info" v-if="receiver === 'other'">
      <div
        class="order-info__block"
      >
        <div class="text _tit">Данные покупателя</div>
        <div class="text">{{ loyalityShopData.buyerData.name }}</div>
        <div class="text">{{ loyalityShopData.buyerData.phone }}</div>
        <div
          class="text"
          v-if="
            isPayCreated ||
            (loyalityShopData.emailRecipient !== 'self' && receiver === 'other')
          "
        >
          {{ loyalityShopData.buyerData.email }}
        </div>

        <div class="inputwrapper" v-else>
          <span
            class="errorblock close"
            v-if="invalidBuyerEmail"
            @click="
              (event) => {
                nextElementFocus(event);
                invalidBuyerEmail = false;
              }
            "
            >{{invalidEmailText}}</span
          >
          <input
            class="input post _disabled-text-hide"
            type="text"
            placeholder="Мой адрес эл. почты"
            v-model="loyalityShopData.buyerData.email"
            ref="emailInput"
            :class="{
              error: invalidBuyerEmail,
            }"
          />
        </div>
      </div>

      <div
        class="order-info__block"
      >
        <div class="text _tit" v-if="receiver === 'other'">
          Данные будущего владельца
        </div>
        <div class="text">{{ loyalityShopData.clientData.name }}</div>
        <div class="text">{{ loyalityShopData.clientData.phone }}</div>
        <div
          class="text"
          v-if="isPayCreated || loyalityShopData.emailRecipient !== 'other'"
        >
          {{ loyalityShopData.clientData.email }}
        </div>

        <div class="inputwrapper" v-else>
          <button
            class="errorblock close"
            v-if="invalidClientEmail"
            @click="
              (event) => {
                nextElementFocus(event);
                invalidClientEmail = false;
              }
            "
          >
            {{invalidEmailText}}
          </button>
          <input
            class="input post _disabled-text-hide"
            type="text"
            placeholder="Эл. почта будущего владельца"
            v-model="loyalityShopData.clientData.email"
            ref="emailInput"
            :class="{
              error: invalidClientEmail,
            }"
          />
        </div>
      </div>
    </div>

    <div v-else>
      <div class="text _tit" v-if="receiver === 'other'">
        Будущий владелец
      </div>
      <div class="text">{{ loyalityShopData.clientData.name }}</div>
      <div class="text">{{ loyalityShopData.clientData.phone }}</div>
      <div class="text">
        {{ loyalityShopData.clientData.email }}
      </div>
    </div>
    <div class="order-info__title">
      {{
        currentLoyalityKind === "certificate"
          ? "приобретаемый сертификат:"
          : "приобретаемый абонемент:"
      }}
      {{titleStr}}
    </div>
    <div class="srok text mb-10px">
      <span class="time">{{ currentBuyLoyality.expiration }}</span>
      <span class="price"
        >{{
          (currentLoyalityKind === "certificate"
            ? currentBuyLoyality.type.balance
            : currentBuyLoyality.type.cost
          ).toLocaleString()
        }}
        ₽</span
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch, ref } from "vue";
import { useStore } from "vuex";
import { TypeLoyalityKinds, TypeLoyaliyMainName } from "@/types";
import { IloyalityShopData, TypeReceiver } from "@/types/typesOfState";
import { Store } from "vuex";
import getExpirationStringForAbonement from "@/functions/getExpirationStringForAbonement";
import getExpirationStringForCertificate from "@/functions/getExpirationStringForCertificate";
import nextElementFocus from "@/functions/nextElementFocus";

const store = useStore();

const loyalityShopData = computed<IloyalityShopData>(
  () => store.state.loyalityShopData
);
const currentLoyalityKind = computed<TypeLoyalityKinds>(
  () => store.state.currentLoyalityKind
);

const loyalityTypes = computed(() => store.state.allLoyalityTypes);

const receiver = computed<TypeReceiver>(
  () => store.state.loyalityShopData.receiver
);

const emailRecipient = computed<TypeReceiver>(
  () => store.state.loyalityShopData.emailRecipient
);

const isPayCreated = computed(() => !!store.state.currentPaymentData.OrderId);

const currentBuyLoyality = computed(() => {
  const currentBuy = [
    ...loyalityTypes.value.certificates,
    ...loyalityTypes.value.abonements,
  ].find((i) => i.id === loyalityShopData.value.buyLoyalityType);

  const expiration =
    currentLoyalityKind.value === "certificate"
      ? getExpirationStringForCertificate(currentBuy)
      : getExpirationStringForAbonement(currentBuy);

  return {
    type: currentBuy,
    expiration: expiration,
  };
});

const titleStr = computed(() => {
  return currentBuyLoyality.value.type.title.replace(/\//g, '|');
})

const invalidClientEmail = ref<boolean>(false);
const invalidBuyerEmail = ref<boolean>(false);
let invalidEmailText = ref<
  "Укажите корректный Email" | "Этот Email уже указан выше"
>();
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateFinishForm(): boolean {
  const clientEmail = loyalityShopData.value.clientData.email || null;
  const buyerEmail = loyalityShopData.value.buyerData.email || null;
  if (receiver.value === "self") {
    return true;
  } else {
    if (emailRecipient.value === "self") {
      const validatorValue = !!(buyerEmail && emailRegex.test(buyerEmail));

      if (validatorValue && clientEmail === buyerEmail) {
        loyalityShopData.value.clientData.email = null
      }

      invalidBuyerEmail.value = !validatorValue;

      return validatorValue;
    } else {
      if (!clientEmail || !emailRegex.test(clientEmail)) {
        invalidEmailText.value = "Укажите корректный Email"
        invalidClientEmail.value = true;
        return false
      } else if (clientEmail === buyerEmail) {
        invalidEmailText.value = "Этот Email уже указан выше"
        invalidClientEmail.value = true;
        return false
      } else {
        invalidClientEmail.value = false;
        return true
      }
    }
  }
}

defineExpose({ validateFinishForm });
</script>

<style lang="scss" scoped>
.step-finish__title {
  width: 100%;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 20px;
  &__block {
    padding: 10px;
    border: 1px solid #4b433c;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    position: relative;
  }
  &__radio {
    position: absolute;
    top: 18px;
    right: 6px;
  }
}
.srok {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 300;
}

.mb-10px {
  margin-bottom: 10px !important;
}

.head {
  font-size: 16px;
}
.text {
  margin: 0;
  font-size: 15px;
  font-weight: 300;
  &._tit {
    font-size: 18px;
  }
}
.text.send {
  margin-top: 24px;
  font-weight: 400;
}
.text.sendnum {
  font-weight: 400;
}
.text.future {
  margin: 24px 0 8px;
  font-weight: 400;
}
.text.owner {
  margin: 24px 0 16px;
}
.text.ownermail {
  font-weight: 400;
}
</style>
